__webpack_require__.p = "/minimal-academic-folio/";